<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-data-table
          :headers='headers'
          :items='itens'
          class='elevation-1'
          :items-per-page="itemsPerPage"
          @update:items-per-page=" v => itemsPerPage = v"
        >
          <template #top>
            <v-toolbar flat color='white'>
              <v-toolbar-title>{{ $t('keywords.listing') }}</v-toolbar-title>
              <v-divider class='mx-4' inset vertical></v-divider>
              <v-btn color='primary' dark class='mb-2' @click="editItem(null)">{{ $t('button.new') }}</v-btn>
              <v-spacer/>
            </v-toolbar>
            <SearchField v-model="searchUsername" />
          </template>
          <template #item.actions='{ item }'>
            <v-tooltip bottom>
              <template #activator='{ on }'>
                <v-icon v-on="on" color="blue" small class='mr-2' @click.stop="showModalHandler(item.userKey.username)" :disabled="!canChangePassword(item)">mdi-key</v-icon>
              </template>
              <span>{{ $t('user.change_password') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator='{ on }'>
                <v-icon v-on="on" color="orange" small class='mr-2' @click='editItem(item)'>mdi-pencil</v-icon>
              </template>
              <span>{{ $t('button.edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator='{ on }'>
                <v-icon v-on="on" color="red" small class='mr-2' @click='deleteItem(item)'>mdi-delete</v-icon>
              </template>
              <span>{{ $t('button.delete') }}</span>
            </v-tooltip>
          </template>
          <template #item.permission="{ item: { permission } }">
            <v-chip :key="permission" class="mr-2">{{permission}}</v-chip>
          </template>
          <template #item.permissions="{ item }">
            <v-chip v-for="par in item.permissions" :key="par" class="mr-2">{{par}}</v-chip>
          </template>
          <template #no-data>
            {{ $t('warnings.no_data_found') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <ModalPassword v-model="modalData" />
  </v-container>
</template>

<script>
import Servico from '@/services/UserService'
import ModalPassword from './modal-password'
import LocalStorageService from '@/services/LocalStorageService'
import SearchField from '../core/SearchField.vue'
import IncludesIgnoreCase from '../../utils/IncludesIgnoreCase'

export default {
  name: 'UserGrid',
  components: {
    ModalPassword,
    SearchField
  },
  data: () => ({
    itens: [],
    searchUsername: '',
    modalData: {
      show: false,
      username: ''
    }
  }),

  mounted () {
    this.searchAll()
  },

  computed: {
    version () { return this.$versionable.versions.users },
    itemsPerPage: {
      get () {
        return this.$cookies.isKey('user_per_page') ? parseInt(this.$cookies.get('user_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('user_per_page', value)
      }
    },
    headers () {
      return [
        {
          text: this.$t('keywords.username'),
          value: 'userKey.username',
          sortable: true,
          align: 'start',
          filter: username => IncludesIgnoreCase(username, this.searchUsername)
        },
        {
          text: this.version > '1.0.0' ? this.$t('user.permissions') : this.$t('user.permission'),
          value: this.version > '1.0.0' ? 'permissions' : 'permission',
          sortable: false,
          align: 'center'
        },
        {
          text: this.$t('keywords.actions'),
          value: 'actions',
          sortable: false
        }
      ].filter(h => h.show ?? true)
    }
  },

  methods: {
    hasPermission (user, ...validPermissions) {
      return this.$versionable.decorators.users.hasPermission(user, ...validPermissions)
    },
    searchAll () {
      const clientUrlPrefix = LocalStorageService.getClientPrefix()
      Servico.findAll(clientUrlPrefix)
        .then((result) => (this.itens = result.data))
    },

    editItem (item) {
      this.$emit('editItem', false, item)
    },

    editPassword (item) {

    },

    deleteItem (item) {
      if (confirm(this.$t('warnings.confirm.delete'))) {
        Servico.delete(item)
          .then((result) => {
            this.searchAll()
          })
          .catch((error) => {
            console.error(`${this.$t('warnings.error.delete')} : ${error}`)
          })
      }
    },

    showModalHandler (username) {
      this.modalData.username = username
      this.modalData.show = true
    },

    canChangePassword (user) {
      const loggedUser = LocalStorageService.getUserDetails()

      if (user.userKey.username === loggedUser.userKey.username) return true

      if (this.hasPermission(user, 'MASTER') && user.userKey.username !== loggedUser.userKey.username) return false

      if (this.hasPermission(loggedUser, 'ADMINISTRADOR')) return true

      return false
    }
  }
}
</script>
